<script setup>
const props = defineProps({
    btnName: {
        type: String
    },
})
</script>

<template>
    <button
        type="submit"
        class="font-kantumruy-pro-hanuman-sans rounded-md flex justify-center items-center px-8 py-1.5 overflow-hidden relative group cursor-pointer border border-primaryColor font-bold bg-primaryColor">
        <span class="absolute w-full h-0 transition-all duration-300 origin-center rotate-45 -translate-x-32 bg-white -top-0 group-hover:h-[1200px] group-hover:w-[1200px] group-hover:-translate-y-32 ease"></span>

        <span class="relative text-white transition duration-300 group-hover:text-primaryColor ease text-center">
            {{ props.btnName }}
        </span>
    </button>
</template>
